import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICountry } from "../../../Pages/Country/ICountry";

export const AddCountrySlice = createSlice({
  name: "AddCountrySlice",
  initialState: {} as IReduxState<ICountry>,
  reducers: {
    addCountry: (state, _: PayloadAction<ICountry>) => {
      state.isLoading = true;
    },
    successaddCountry: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddCountry: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddCountryResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addCountry,
  failureaddCountry,
  successaddCountry,
  clearAddCountryResponse,
} = AddCountrySlice.actions;

export default AddCountrySlice.reducer;
